import { coreDataStore, getClientPlayer } from "../../helper/CoreDataStorage";
import { audio_engine } from "../core/AudioEngine";
import { setOrientation } from "../effects/Orientation";

export class SoundEffect {
  private sound: Howl;
  private id: number;
  private orientationTimer?: number;

  constructor(src: string) {
    this.id = Date.now();
    this.sound = new Howl({
      src: [src],
      autoplay: true,
      html5: false,
      loop: false,
      volume: audio_engine.effect_volume,
      onend: () => {
        if (this.orientationTimer) {
          clearInterval(this.orientationTimer);
        }

        audio_engine.sound_effects = audio_engine.sound_effects.filter(
          (e) => e !== this,
        );
      },
    });

    audio_engine.sound_effects.push(this);
  }

  applyOrientation(uuid: string, posX: number, posY: number, posZ: number) {
    this.orientationTimer = setInterval(() => {
      let player = getClientPlayer(uuid);
      if (player != null) {
        setOrientation(
          this.sound,
          player.x,
          player.y,
          player.z,
          player.yaw,
          player.pitch,
          posX,
          posY,
          posZ,
        );
      }
    }, 1000 / 20);
  }

  updateVolume() {
    this.sound.volume(audio_engine.effect_volume);
  }

  stop() {
    if (this.orientationTimer) {
      clearInterval(this.orientationTimer);
    }
    this.sound.stop();
  }
}
